import PulseLoader from 'react-spinners/PulseLoader';

import './../spinner/Spinner.scss';

function Spinner() {
  return (
    <div className="spinner-container">
      <PulseLoader className="scale-loader-spinner"
        color={'#180a48'}
        loading={true}
        size={40}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
      <div className="spinner-text-container">
        <span className="spinner-text">Please wait while we load your data...</span>
      </div>
  </div>
  );
}

export default Spinner;
